/** @jsx jsx */
import React, { Fragment } from 'react'
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import { Swiper, SwiperSlide } from 'swiper/react/swiper-react'
import { SwiperWrap } from '@styles/base.style'
import { isMobile } from 'react-device-detect'
import { AdvButton } from '@components/Button'
import { YouTubeEmbed } from 'react-social-media-embed'
import { Button } from '@styles/button.style'
import { SportIssueCardWrap, SportIssueListWrap } from '@views/Matchup/MatchUpDetail/index.style'
import { MATCH_INSIGHT_TYPE, SPORT_ISSUE_TYPE } from '@v2/constants/sport-issue'
import PopupUtils from '@utils/popup-utils'
import { Schema$SportIssue, Schema$SportTalkPickUserInfo } from '@interface/sport-issue'
// img
import popularSearchSlideImg from '@assets/images/bg/sport-issue-popular-search-slide.jpg'
import _ from 'lodash'
import useRootStore from '@store/useRootStore'
import { FreeMode, Pagination } from 'swiper'
import AdvImg from '@components/AdvImg'
import { AnalysisProfile } from '@views/Matchup/MatchUpDetail/TabContent/SportTalkContents/AnalysisProfile'
import Login from '@views/Login'
import { FROM_VIEW_TYPE, PICK_WRITER_TYPE } from '@v2/constants/common'
import { SPORT_ID } from 'adv-protocol/src/GameCommon'
import { ScoreTimelineItem } from '@views/Matchup/MatchUpDetail/TabContent/SportTalkContents/ScoreTimelineItem'
import { HalftimeTimelineItem } from '@views/Matchup/MatchUpDetail/TabContent/SportTalkContents/HalftimeTimelineItem'
import { TimelineEventType } from '@interface/chat'
import { getMatchInsightByTimeline } from '@utils/utils'
import { Schema$SimpleMatchTrack } from '@interface/matchup'
import { SportIssueSwiper } from '@views/Matchup/MatchUpDetail/TabContent/SportTalkContents/SportIssueSwiper'
import DialogUtils from '@utils/dialog-utils'

interface SportIssueListProps {
  track: Schema$SimpleMatchTrack
  matchId: number
  issuePreviewList: Schema$SportIssue[]
  pickUserInfos: Schema$SportTalkPickUserInfo[]
}

export const SportIssueList: React.FC<SportIssueListProps> = observer((props: SportIssueListProps) => {
  const { track, matchId, issuePreviewList, pickUserInfos } = props
  const { userPickStore, companyPickStore, authStore, globalStore } = useRootStore()
  const isDashboardEnabled = globalStore.getSportTalkDashboardEnabled()

  const { sportId } = track

  const homeTeamEmblemUrl = track?.homeTeamEmblem
  const awayTeamEmblemUrl = track?.awayTeamEmblem
  const homeTeamName = track?.homeTeamName
  const awayTeamName = track?.awayTeamName

  // 대시보드 팝업 출력 이벤트
  const onClickSportIssueDetailPopup = () => {
    PopupUtils.showSportIssuePopup(track, matchId, pickUserInfos)
  }

  const makeSportIssueSlides = (data: Schema$SportIssue[]) => {
    return _.map(data, (item, index) => {

      let contents: JSX.Element
      let contentsTxt: string
      let onclickSwipeItem: (() => void) | null = null

      if (item.sportIssueType === SPORT_ISSUE_TYPE.POPULAR_SEARCH_TERM_NEWS) {
        {/************* 이슈키워드(인기검색어) *************/}
        contents = <AdvImg src={popularSearchSlideImg} alt="now 이슈키워드" srcMode={'small'}/>
        contentsTxt = item.content
        onclickSwipeItem = () => {
          PopupUtils.showPopularSearchTermPopup(item.popularSearchTerm)
        }
      } else if (item.sportIssueType === SPORT_ISSUE_TYPE.MATCH_INSIGHT) {
        const { matchInsightType, attachment } = item.matchInsight

        if (matchInsightType === MATCH_INSIGHT_TYPE.IMAGE) {
          {/************* 스포츠정보_이미지/gif *************/}
          contents = <AdvImg src={attachment} srcMode={'small'} alt={item.content}/>
          contentsTxt = item.content
          onclickSwipeItem = () => {
            DialogUtils.showSportIssueContent({
              custom: (
                <SportIssueSwiper data={issuePreviewList} id={item.matchInsight.id} scoreData={{
                  homeTeamName,
                  awayTeamName,
                  homeTeamEmblemUrl,
                  awayTeamEmblemUrl,
                  sportId,
                }}/>
              ),
            })
          }
        } else if (matchInsightType === MATCH_INSIGHT_TYPE.URL) {
          {/************* 스포츠정보_URL *************/}
          contents = <div className="embed-wrap"><YouTubeEmbed url={attachment} width={'292px'} height={'164px'}/></div>
          contentsTxt = item.content
          onclickSwipeItem = () => {
            DialogUtils.showSportIssueContent({
              custom: (
                <SportIssueSwiper data={issuePreviewList} id={item.matchInsight.id} scoreData={{
                  homeTeamName,
                  awayTeamName,
                  homeTeamEmblemUrl,
                  awayTeamEmblemUrl,
                  sportId,
                }}/>
              ),
            })
          }
        } else if (matchInsightType === MATCH_INSIGHT_TYPE.TIMELINE) {
          const matchInsight = getMatchInsightByTimeline({
            timeline: item.matchInsight.timeline.content,
            homeTeamName,
            awayTeamName,
            homeTeamEmblemUrl,
            awayTeamEmblemUrl,
          })

          const {
            eventType, scoreTeamName, scoreTime, goalScorer, emblemUrl, homeTeamScore, awayTeamScore,
          } = matchInsight

          if (sportId === SPORT_ID.SOCCER) {
            if (eventType === TimelineEventType.SCORE_CHANGE) {
              {/************* 스포츠정보_득점 타임라인 *************/}
              contents = (
                <ScoreTimelineItem scoreTimelineData={{
                  teamName: scoreTeamName,
                  time: scoreTime,
                  playerName: goalScorer,
                  teamEmblemUrl: emblemUrl,
                }}/>)
              contentsTxt = `${homeTeamName} ${homeTeamScore}:${awayTeamScore} ${awayTeamName}`
              onclickSwipeItem = () => {
                DialogUtils.showSportIssueContent({
                  custom: (
                    <SportIssueSwiper
                      data={issuePreviewList}
                      id={item.matchInsight.id}
                      scoreData={{
                        homeTeamName,
                        awayTeamName,
                        homeTeamEmblemUrl,
                        awayTeamEmblemUrl,
                        sportId,
                      }}
                    />
                  ),
                })
              }
            } else if (eventType === TimelineEventType.PERIOD_SCORE) {
              {/************* 스포츠정보_전반전 종료 타임라인 *************/}
              contents = (
                <HalftimeTimelineItem scoreTimelineData={{
                  homeTeamEmblemUrl: homeTeamEmblemUrl,
                  awayTeamEmblemUrl: awayTeamEmblemUrl,
                  homeTeamName: homeTeamName,
                  awayTeamName: awayTeamName,
                  homeTeamScore: homeTeamScore,
                  awayTeamScore: awayTeamScore,
                  sportId: sportId,
                }}/>)
              contentsTxt = `${homeTeamName} ${homeTeamScore}:${awayTeamScore} ${awayTeamName}`
              onclickSwipeItem = () => {
                DialogUtils.showSportIssueContent({
                  custom: (
                    <SportIssueSwiper
                      data={issuePreviewList}
                      id={item.matchInsight.id}
                      scoreData={{
                        homeTeamName,
                        awayTeamName,
                        homeTeamEmblemUrl,
                        awayTeamEmblemUrl,
                        sportId,
                      }}
                    />
                  ),
                })
              }
            }
          }
        }
      }

      const sportIssueElem = (
        <Fragment>
          {contents}
          <p className="contents-txt">{contentsTxt}</p>
        </Fragment>
      )

      return (
        <SwiperSlide className="swipe-item" key={index}>
          <AdvButton
            width={'100%'}
            contents={sportIssueElem}
            onClick={onclickSwipeItem}
            className="issue-item"
          />
        </SwiperSlide>
      )
    })
  }

  const makeAnalysisSlidesSlides = () => {
    return _.map(pickUserInfos, (item, index) => {
      const { userPromiseId, targetId } = item
      const onClickAnalysisBtn = async () => {
        if (!authStore.isSignedIn) {
          authStore.showLoginPopup(<Login/>)
        } else {
          if (item.pickWriterType === PICK_WRITER_TYPE.USER_PICK) { //s 멤버십 경기분석 팝업창
            try {
              await userPickStore.fetchMatch(matchId)
              PopupUtils.showUserPickList({
                targetUserPickId: targetId,
                fromView: FROM_VIEW_TYPE.MATCHUP_DETAIL_CHEER_FOR_TEAM,
              })
            } catch (error) {
              console.error(error)
            }
          } else if (item.pickWriterType === PICK_WRITER_TYPE.COMPANY_PICK) { //프리미엄 분석가 경기분석 팝업창
            try {
              await companyPickStore.fetchCompanyPick(targetId)
              await companyPickStore.fetchCompanyPickManagers({
                userPromiseIds: [userPromiseId],
              })
              PopupUtils.showCompanyPickDetailPopup()
            } catch (error) {
              console.error(error)
            }
          }
        }
      }

      return (
        <SwiperSlide className="swipe-item analysis-profile" key={index}>
          <AdvButton
            width={'100%'}
            contents={<AnalysisProfile userInfo={item}/>}
            onClick={onClickAnalysisBtn}
          />
        </SwiperSlide>
      )
    })
  }

  // 스포츠톡 - 대시보드의 슬라이드 갯수가 5개까지만 출력되도록 처리
  const dashboardPreviewLists = _.slice(issuePreviewList, 0, 5)
  const slides = makeSportIssueSlides(dashboardPreviewLists)
  const analysisSlides = makeAnalysisSlidesSlides()
  let sportIssueListContents: JSX.Element
  if (isMobile) {
    sportIssueListContents = (
      <SwiperWrap className="quick-swipe">
        {slides}
        {isDashboardEnabled && analysisSlides}
      </SwiperWrap>
    )
  } else {
    sportIssueListContents = (
      <SwiperWrap className="p-18 right-navigation">
        <Swiper
          slidesPerView={'auto'}
          pagination={!isMobile && _.size(issuePreviewList) > 0 && { type: 'fraction', clickable: false }}
          navigation={!isMobile}
          spaceBetween={14}
          loop={false}
          shortSwipes
          modules={[FreeMode, Pagination]}
        >
          {slides}
          {isDashboardEnabled && analysisSlides}
        </Swiper>
      </SwiperWrap>
    )
  }

  return (
    <SportIssueListWrap>
      <div className="sport-issue-title">
        <h3 className="tit">대시보드</h3>
        <Button TP onClick={onClickSportIssueDetailPopup} className="all-btn">전체보기</Button>
      </div>
      <SportIssueCardWrap className={!isMobile && 'pc'}>
        {sportIssueListContents}
      </SportIssueCardWrap>
    </SportIssueListWrap>
  )
})
